import {
  KPI_OPTIMAL_BADGE_COLOR,
  KPI_CRITICAL_BADGE_COLOR,
  KPI_CAUTION_BADGE_COLOR,
} from '../../../../themes/tokens';
import { ChartData } from './types';

export const getBarColor = (item: ChartData) => {
  if (typeof item.rawValue === 'number') {
    if (item.benchmarkMax && item.rawValue > item.benchmarkMax) return KPI_OPTIMAL_BADGE_COLOR;
    if (item.benchmarkMin && item.rawValue < item.benchmarkMin) return KPI_CRITICAL_BADGE_COLOR;
    return KPI_CAUTION_BADGE_COLOR;
  } else {
    return KPI_CAUTION_BADGE_COLOR;
  }
};
